export default "__VITE_ASSET__BJkJKKKC__"